import {HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'BV360 Benefits Request Form',
      redirectLink: '/assets/completed-request.pdf',
    },
    {
      title: 'Bioventus Reimbursement Guide',
      redirectLink: '/assets/download-guide.pdf',
    },
    {
      title: 'Sample CMS 1500 Form for DUROLANE',
      redirectLink: '/assets/DUROLANE-CMS1500-Sample-Form.pdf',
    },
    {
      title: 'Sample Letter of Medical Necessity',
      redirectLink: '/assets/BV360-LMN.docx',
    },
    {
      title: 'Patient Direct Purchase Form',
      redirectLink: '/assets/download-pdp-form.pdf',
    },
    // {
    //   title: 'Patient Direct Purchase Form for Durolane/Gelsyn-3',
    //   redirectLink: '/assets/pdp-gelsyn-durolane.pdf',
    // },
    {
      title: 'Patient Assistance Request Form',
      redirectLink: '/assets/download-pap-form.pdf',
    },
    {
      title: 'GELSYN-3 Rebate Coupon',
      redirectLink: '/assets/download-gelsyn-rebate.pdf',
    },
    {
      title: 'DUROLANE Rebate Coupon',
      redirectLink: '/assets/download-durolane-rebate.pdf',
    },
    {
      title: 'Specialty Pharmacy Handout for Patients',
      redirectLink: '/assets/download-tear-pad.pdf',
    },
    {
      title: 'Aetna Sample',
      redirectLink: '/assets/download-aetna-sample.pdf',
    },
    {
      title: 'Anthem Sample',
      redirectLink: '/assets/download-anthem-sample.pdf',
    },
    {
      title: 'BCBS MI Sample',
      redirectLink: '/assets/download-bcbsmi-sample.pdf',
    },
    {
      title: 'BCBS NC Sample',
      redirectLink: '/assets/download-bcbsnc-sample.pdf',
    },
    {
      title: 'BCBS TX Sample',
      redirectLink: '/assets/download-bcbstx-sample.pdf',
    },
    {
      title: 'United Healthcare Sample',
      redirectLink: '/assets/download-uhc-sample.pdf',
    },
    {
      title: 'Care Coordinator Sample',
      redirectLink: '/assets/download-cc-sample.pdf',
    },
  ]
};

export const PublicHeader: HeaderElement[] = [
  {
    title: 'Welcome',
    redirectLink: '/users/sign_in',
    actionType: HeaderElementType.ROUTE,
  },
  // {
  //   title: 'Enrollment',
  //   redirectLink: '/enrollments/new',
  //   actionType: HeaderElementType.ROUTE,
  // },
  {
    title: 'Request Form',
    redirectLink: '/assets/completed-request.pdf',
    actionType: HeaderElementType.LINK,
  },
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  
  {
    title: '',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {} as unknown as HeaderElement,
  resourcesHeader,
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Submit a Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  resourcesHeader,
];


